export default __webpack_public_path__ + "static/media/CollisionsImg.032cc85b.jpg";